import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { WagmiProvider } from 'wagmi';
import { SatsWagmiConfig } from '@gobob/sats-wagmi';
import { DEFAULT_NETWORK } from 'constants/general';
import { wagmiConfig } from 'configs/wagmi';
import { Bounce, ToastContainer } from 'react-toastify';
const satsQueryClient = new QueryClient();
const evmQueryClient = new QueryClient();
export const Providers = ({ children }) => {
    return (_jsxs(_Fragment, { children: [_jsx(QueryClientProvider, { client: satsQueryClient, children: _jsx(SatsWagmiConfig, { network: DEFAULT_NETWORK, queryClient: satsQueryClient, children: _jsx(WagmiProvider, { config: wagmiConfig, children: _jsx(QueryClientProvider, { client: evmQueryClient, children: children }) }) }) }), _jsx(ToastContainer, { position: "top-center", transition: Bounce })] }));
};
